export default __webpack_public_path__ + "static/ID700-ios-large-2-77acdb167008a6c80b381444b8351b49.png";